import { render, staticRenderFns } from "./RetentionRulesTable.vue?vue&type=template&id=7d2d9885&"
import script from "./RetentionRulesTable.vue?vue&type=script&lang=js&"
export * from "./RetentionRulesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports